module.exports = __webpack_public_path__ + "img/2.001ab4ac.jpg";